import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/banner_hero';

export interface BannerHero {
    content_banner_hero_title: string | null;
    content_banner_hero_description: string | null;
    content_banner_hero_image: string | null;
}

export interface GetBannerHeroSuccessResponse {
    data: BannerHero;
    success: boolean;
    message: string;
}

export const useGetBannerHero = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [hero, setHero] = useState<BannerHero | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar banner hero') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetBannerHeroSuccessResponse = await response.json();

            setHero(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar banner hero');
        } finally {
            setLoading(false);
        }
    };

    return { hero, request, loading, error };
};
